import { useUpdateEffect } from 'ahooks';
import { Select, SelectProps } from 'antd';
import { FC, memo, useState } from 'react';
import { ChevronDown, Search } from 'react-bootstrap-icons';

import { FormSelectNotFoundContent } from '@/common/components';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteHostingAccountsMutation } from '@/modules/Hostings';

interface Props extends Omit<SelectProps, 'notFoundContent' | 'options' | 'placeholder'> {
  hostingId: string | undefined;
}

export const HostingsAccountsAutocomplete: FC<Props> = memo((props) => {
  const { hostingId, loading, value, disabled } = props;

  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);

  const { data, isError, error, isLoading, mutate, reset } = useAutocompleteHostingAccountsMutation()();

  useUpdateEffect(() => {
    if (hostingId) {
      mutate(hostingId);
    } else {
      props.onChange?.(undefined, []);
      reset();
    }

    return () => {
      props.onChange?.(undefined, []);
    };
  }, [hostingId]);

  return (
    <Select
      { ...props }
      notFoundContent={
        <FormSelectNotFoundContent
          description="Немає акаунтів хостингу"
          isError={ isError }
          error={ error }
        />
      }
      placeholder="Виберіть акаунт хостингу"
      loading={ loading || isLoading }
      disabled={ isLoading || !hostingId || disabled }
      value={ isLoading ? undefined : value }
      options={ parseSelectData(data, {
        value: 'id',
        label: 'login'
      }) }
      onDropdownVisibleChange={ setDropdownIsOpen }
      defaultActiveFirstOption={ false }
      filterOption={ false }
      suffixIcon={
        dropdownIsOpen ? <Search/> : <ChevronDown/>
      }
    />
  );
});
